var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchEmpty = function SvgSearchEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m32.5 32.5-6.032-6.032m0 0a11.077 11.077 0 0 0 3.254-7.857c0-6.136-4.974-11.111-11.11-11.111C12.474 7.5 7.5 12.475 7.5 18.611c0 6.137 4.975 11.111 11.111 11.111 3.068 0 5.846-1.243 7.857-3.254Z"
  })));
};
export default SvgSearchEmpty;